import type { UsedFinanceInsurancePayload } from "../../utils/financeUtils";
import {
    type UscInsuranceActionsType,
    INSURANCE_SET_FAILED,
    INSURANCE_SET_QUOTE,
    INSURANCE_SET_QUOTE_ID,
} from "../actions/UscInsuranceActions";
import type { UscInsuranceQuoteType } from "../../utils/insuranceUtils";

export type UscInsuranceReducerType = {
    quote: UscInsuranceQuoteType | null;
    insuranceQuoteId: string | null;
    failed: boolean;
    latestPayload: UsedFinanceInsurancePayload | null;
};

export const initialUscInsuranceState: UscInsuranceReducerType = {
    quote: null,
    insuranceQuoteId: null,
    failed: false,
    latestPayload: null,
};

const UscInsuranceReducer = (
    state: UscInsuranceReducerType = initialUscInsuranceState,
    action: UscInsuranceActionsType,
): UscInsuranceReducerType => {
    switch (action.type) {
        case INSURANCE_SET_QUOTE: {
            return {
                ...state,
                quote: action.quote,
                insuranceQuoteId: action.quote?.quoteId || null,
                latestPayload: action.payload,
            };
        }

        case INSURANCE_SET_FAILED: {
            return { ...state, failed: action.failed, latestPayload: action.payload };
        }

        case INSURANCE_SET_QUOTE_ID: {
            return { ...state, insuranceQuoteId: action.insuranceQuoteId };
        }

        default:
            return state;
    }
};

export default UscInsuranceReducer;
